import { SSOAPIBaseError } from './sso-api-base-error';

export class ErrorUtil {
    public static recurseGetRenderedPreTagErrorMessage(err: SSOAPIBaseError) {
        let msg = err.message;
        let curErr: Error | undefined = err.cause;
        while (curErr) {
            msg += `<br />  [cause]: ${curErr.message}`;
            if (curErr instanceof SSOAPIBaseError) {
                curErr = curErr.cause;
            } else {
                curErr = undefined;
            }
        }
        return msg;
    }
}
